import * as sortBy from 'lodash/sortBy'
import * as cn from 'classnames'
import { AccountType, AggregatedBalanceByCategory } from 'interfaces/accounts'
import * as styles from 'styles/organisms/modules/Breakdown.css'
import BreakdownChart from 'components/atoms/charts/BreakdownChart'
import PeergroupLegend from 'components/features/pfm/PeergroupLegend/PeergroupLegend'
import { Collection } from 'interfaces/index'
import { getItemsByKey, getItemsFromCollection } from 'helpers/normalizeHelpers'
import { CategoryId, CollectionCategory } from 'interfaces/meta'
import { getTrackerCategoryName } from 'helpers/categoriesHelpers'
import { ALL_CATEGORY_ID } from 'constants/meta'
import SvgIcon from 'components/atoms/SvgIcon'

export type AccountsBreakdownOwnProps = {
  type: AccountType
}

export type AccountsBreakdownStateProps = {
  categories: CollectionCategory
  memberValue: Collection<AggregatedBalanceByCategory, 'category'>
  otherValue: Collection<AggregatedBalanceByCategory, 'category'>
  peerValue: Collection<AggregatedBalanceByCategory, 'category'>
  selectedCategoryId: CategoryId
  othersName: string
  withComparison: boolean
}

export type AccountsBreakdownProps = AccountsBreakdownStateProps & AccountsBreakdownOwnProps

const AccountsBreakdown = (props: AccountsBreakdownProps) => {
  const {
    categories,
    memberValue,
    peerValue,
    otherValue,
    othersName,
    selectedCategoryId,
    type,
    withComparison,
  } = props

  const notAllCategorySelected = selectedCategoryId !== ALL_CATEGORY_ID

  const [allCategoryBreakdown, ...restBreakdowns] = notAllCategorySelected ?
    getItemsByKey(memberValue.byKey, [ALL_CATEGORY_ID, selectedCategoryId]) :
    getItemsFromCollection(memberValue)

  const memberValueArray = [allCategoryBreakdown].concat(sortBy(restBreakdowns, 'amount').reverse())

  const {
    amount: memberAmount,
  } = memberValue.byKey[ALL_CATEGORY_ID]
  const {
    amount: peerAmount,
  } = peerValue.byKey[ALL_CATEGORY_ID]
  const {
    amount: otherAmount,
  } = otherValue.byKey[ALL_CATEGORY_ID]

  const maxBalance = Math.max(memberAmount, peerAmount, otherAmount)

  return (
    <ul>
      <li className={ styles.legendWrapper }>
        <PeergroupLegend othersName={ othersName } />
      </li>
      {
        memberValueArray.map(({ category: categoryId, amount }: AggregatedBalanceByCategory, idx) => {
          const categorySelected = notAllCategorySelected && selectedCategoryId === categoryId
          const category = categories.byKey[categoryId]
          const peerAccount = peerValue.byKey[categoryId]
          const otherAccount = otherValue.byKey[categoryId]

          const categoryName = getTrackerCategoryName(category, type)

          let iconKind = categoryId
          if (categoryId === ALL_CATEGORY_ID) {
            iconKind = type === 'debts' ? 'debts' : 'assets'
          }

          const iconSource = require(`icons/${ iconKind }.svg`).default

          return (
            <li key={ idx } className={ cn(styles.breakdown, styles.accountBreakdown) }>
              <div className={ styles.nameWrapper }>
                <i className={ styles.icon } >
                  <SvgIcon src={ iconSource } />
                </i>
                <span className={ styles.name }>{ categoryName }</span>
              </div>
              <BreakdownChart
                memberValue={ amount }
                peerValue={ peerAccount.amount }
                otherValue={ otherAccount.amount }
                maxTotal={ maxBalance }
                isExpanded={ categorySelected }
                withComparison={ withComparison }
              />
            </li>
          )
        })
      }
    </ul>
  )
}

export default AccountsBreakdown
